let w = window.innerWidth;
if (w < 991) {
    var swiper_full = new Swiper('.full-carousel', {
        slidesPerView: "auto",
        spaceBetween: 12,
        navigation: {
            nextEl: ".full-button-next",
            prevEl: ".full-button-prev"
        }
    });
}

function showTieButons(event) {

    let allpatternsBoxEl = document.querySelectorAll('[data-patternsBox]');
    for (i = 0; i < allpatternsBoxEl.length; i++) {
        allpatternsBoxEl[i].classList.remove('active');
    }
    let patternsBoxEl = event.closest('[data-patternsBox]');
    patternsBoxEl.classList.add('active');
}